var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRatingFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.5196L16.1501 20.0296C16.9101 20.4896 17.8401 19.8096 17.6401 18.9496L16.5401 14.2296L20.2101 11.0496C20.8801 10.4696 20.5201 9.36964 19.6401 9.29964L14.8101 8.88964L12.9201 4.42964C12.5801 3.61964 11.4201 3.61964 11.0801 4.42964L9.19007 8.87964L4.36007 9.28964C3.48007 9.35964 3.12007 10.4596 3.79007 11.0396L7.46007 14.2196L6.36007 18.9396C6.16007 19.7996 7.09007 20.4796 7.85007 20.0196L12.0001 17.5196Z",
    fill: "#AEB3B6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRatingFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rating-filled.d9d98c03348722ce567a30f8dd6cb2ca.svg";